import { Component, Inject, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MomService } from 'src/app/service/mom.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
import { Globals } from 'src/app/service/global';
import { FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AttendeeService } from 'src/app/service/attendee.service';
@Component({
  selector: 'app-preview-share-agenda',
  templateUrl: './preview-share-agenda.component.html',
  styleUrls: ['./preview-share-agenda.component.css']
})
export class PreviewShareAgendaComponent implements OnInit {

  private readonly notifier!: NotifierService;
  byteData: any;
  data: any;
  agendaArray: any = [];
  showLoading = false;
  minuteJSON: any;
  momList: any = [];
  isEmptyMomCont: boolean = false;
  generateNewCon: string = "N";
  curEditMomFlag: string = "Y";
  selectedValue: any = "select";
  curMomStatus: any = "";
  showSendDraftButton: any;
  showResendDraftButton: any;
  currentMomId: any;
  particToggler = true;
  toppingsControl: any = new FormControl([Validators.required]);
  newPresenterList: any = [];

  // url: any;
  constructor(private spinner: NgxSpinnerService, notifierService: NotifierService, public dialog: MatDialog, private globals: Globals, private momService: MomService, protected sanitizer: DomSanitizer, @Inject(MAT_DIALOG_DATA) data: any) {
    this.notifier = notifierService;
    this.data = data;
    this.minuteJSON = this.constructReq();
    this.toppingsControl.setValue(null);
    this.momService.previeShareAgMinutes(this.minuteJSON).subscribe((response) => {
      let file = new Blob([response], { type: 'application/pdf' });
      this.byteData = file;
      var blobUrl = URL.createObjectURL(file);
      // this.url = blobUrl;
      $("#previewMinutes").attr("src", blobUrl);
      this.showLoading = false;
    })
  }

  ngOnInit(): void {

  }
  constructReq() {
    this.minuteJSON = {
      "deletedFlag": 0,
      "fkMeetingEntityId": this.data.meetingInfo.meetingId,
      "orgCode": localStorage.getItem("orgCode"),
      "userId": localStorage.getItem("userId"),
      "visitorTimeZone": this.globals.vTimeZone,
      "decryptKey": "",
      "momStatusCode": "NotSch",
    };
    if (this.data.meetingInfo.isConfidential == 'Y') {
      this.minuteJSON.decryptKey = localStorage.getItem("decryptKey");
    }
    return this.minuteJSON;
  }

  shareAgenda() {
    if (this.toppingsControl.value != undefined && this.toppingsControl.value != null) {
      this.minuteJSON = this.constructReq();
      this.minuteJSON.attendeeList = this.toppingsControl.value;
      this.minuteJSON.previewFlag = "N";
      this.momService.previeShareAgMinutes(this.minuteJSON).subscribe((response) => {
        this.notifier.show({
          type: 'success',
          message: 'The Agenda draft has been sent successfully'
        });
      })
    }
    else {
      this.notifier.show({
        type: 'error',
        message: 'Please Select Participants'
      });
    }
  }

  showAddParticipants() {
    this.particToggler = true
    this.toppingsControl.setValue('');
  }

  hideAddParticipants() {
    this.particToggler = false
    this.toppingsControl.setValue(this.data.meetingInfo.attendeeList)
  }

  callTrigger() {
    this.toppingsControl.setValue(this.toppingsControl.value);
  }

  onToppingRemoved(topping: any, type: any) {
    if (type == 0) {
      const toppings = this.toppingsControl.value as string[];
      this.removeFirst(toppings, topping);
      this.callTrigger();
    }
    else {
      const additionalpart = this.newPresenterList;
      this.removeFirst(additionalpart, topping)
    }
  }
  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }


}
